import { Modal } from 'antd';

interface DeleteTipoServicioConfirmModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export function DeleteTipoServicioConfirmModal({
  open,
  onConfirm,
  onCancel,
  loading,
}: DeleteTipoServicioConfirmModalProps) {
  return (
    <Modal
      title="Confirm Delete"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Delete"
      okButtonProps={{ danger: true }}
    >
      <p>Are you sure you want to delete this tipo servicio? This action cannot be undone.</p>
    </Modal>
  );
}
